import React from 'react';
import {Link} from 'react-router-dom'
import moment from 'jalali-moment'

function NewsItem(props) {
    const newsUrl = `/news/${props.id}`;



    return (
        <div className={props.cols ? props.cols : 'col-md-6 col-lg-4'}>
            <div className="blog-item">
                
                {
                    props.thumb ? (
                        <figure className="blog-thumb">
                            <img src={process.env.REACT_APP_BASE_URL + props.thumb} alt={props.title} />
                        </figure>
                    ) : null
                }

                <div className="blog-content">

                    <h2 className="h5"><Link to={`${process.env.PUBLIC_URL + newsUrl}`}>{props.title}</Link></h2>
                        <p dangerouslySetInnerHTML={{__html: props.excerpt.html}} />
                    <div className="blog-meta">
                        <div>تاریخ: {moment(props.date, 'YYYY/MM/DD').locale('fa').format('YYYY/MM/DD')}</div>
                    </div>
                    
                </div>

            </div>
        </div>
    );
}

export default NewsItem;
